import t from "../locales";
import kwetsbare_klikker from "../assets/images/kwetsbare_klikker.svg";
import slaaploze_scroller from "../assets/images/slaaploze_scroller.svg";
import stressvrije_surfer from "../assets/images/stressvrije_surfer.svg";
import virtuele_verdwaler from "../assets/images/virtuele_verdwaler.svg";
import web_worstelaar from "../assets/images/web_worstelaar.svg";

const IMAGES = {
  kwetsbare_klikker,
  slaaploze_scroller,
  stressvrije_surfer,
  virtuele_verdwaler,
  web_worstelaar,
};

const buildProfile = (slug, index) => ({
  id: slug,
  index: index,
  title: t(`profiles.${slug}.title`),
  image: IMAGES[slug],
  description: t(`profiles.${slug}.description`),
  plan: {
    title: t(`profiles.${slug}.plan.heading`),
    description: t(`profiles.${slug}.plan.description`),
  },
  habits: {
    title: t(`profiles.${slug}.habits.title`),
    choices: {
      1: t(`profiles.${slug}.habits.choices.1`),
      2: t(`profiles.${slug}.habits.choices.2`),
      3: t(`profiles.${slug}.habits.choices.3`),
      4: t(`profiles.${slug}.habits.choices.4`),
    },
  },
  environment: {
    title: t(`profiles.${slug}.environment.title`),
    choices: {
      1: t(`profiles.${slug}.environment.choices.1`),
      2: t(`profiles.${slug}.environment.choices.2`),
      3: t(`profiles.${slug}.environment.choices.3`),
      4: t(`profiles.${slug}.environment.choices.4`),
    },
  },
  devices: {
    title: t(`profiles.${slug}.devices.title`),
    choices: {
      1: t(`profiles.${slug}.devices.choices.1`),
      2: t(`profiles.${slug}.devices.choices.2`),
      3: t(`profiles.${slug}.devices.choices.3`),
      4: t(`profiles.${slug}.devices.choices.4`),
    },
  },
});

const PROFILES = {
  1: buildProfile("slaaploze_scroller", 1),
  2: buildProfile("kwetsbare_klikker", 2),
  3: buildProfile("stressvrije_surfer", 3),
  4: buildProfile("virtuele_verdwaler", 4),
  5: buildProfile("web_worstelaar", 5),
};

export default PROFILES;
